import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useCDN } from '@/utils/cdn';
import classnames from 'classnames';
import Icon from '../Icon';
var Avatar = function(props) {
    var url = props.url, _height = props.height, height = _height === void 0 ? 60 : _height, _width = props.width, width = _width === void 0 ? 60 : _width, className = props.className, style = props.style;
    var s = Object.assign({
        width: width,
        height: height
    }, style);
    return(/*#__PURE__*/ _jsx("div", {
        className: classnames([
            'flex justify-center items-center rounded-full',
            className
        ]),
        style: s,
        children: url ? /*#__PURE__*/ _jsx("img", {
            src: url ? url : useCDN('/img/account@2x.png'),
            className: classnames([
                'w-2/4 h-2/4',
                {
                    'object-contain': !!url
                }
            ]),
            alt: "user"
        }) : /*#__PURE__*/ _jsx(Icon, {
            type: "profile",
            className: classnames(className)
        })
    }));
};
export default Avatar;
